import { ACTIONS } from "../../../Models/ENUM";
import CONQUER from "../../CONQUER";
import GameInstance from "../GameInstance";
import MATH from "../../../UTIL/MATH";
import ARRAY from "../../../UTIL/ARRAY";
import LOG, { log } from "../../../UTIL/LOG";

class UserXP
{
    private conquer         : CONQUER;
    private query           : any;
    private gameInstance    : GameInstance;

    private rankNames       : any = [ "Newbie", "Amateur", "Rookie", "Apprentice", "Trainee", "Athlete", "Semi Pro","Professional", "Rockstar",  "Master", "Conquerer", "Legendary", "Demigod", "Invincible" ];
    private maxLevel        : number = 7;

    private levelUpTable    : any = [ 1, 5, 150, 500, 1000, 2000, 3000, 4000 ];
    public level            : number = 0;
    private varName         : string = "userXP";

    public rank             : string = "";
    public isComplete       : boolean = false;
    public value            : number = 0;
    public nextLevel        : number = 0;
    public max              : number = 0;
    public min              : number = 0;
    public isFull           : boolean = false;
    private maxValue        : number = ARRAY.lastItem( this.levelUpTable );

    constructor( gameInstance:GameInstance )
    {
        this.gameInstance   = gameInstance;
        this.conquer        = gameInstance.conquer;
        this.query          = { gameID:gameInstance.gameID };
    }
 
    public get()
    {
        this.value          = this.gameInstance.Data.data[ this.varName ] || 0;
 
        this.refresh();

        this.gameInstance.Data.set( "userLevel", this.level );

        return this.level;
    }

    public increase( amount:number=1 )
    {
        this.value          = MATH.clamp( this.value + amount, this.maxValue );
 
        var lastlevel       = this.level;
 
        this.gameInstance.Data.set( this.varName, this.value );
 
        this.get();
 
        if( lastlevel <= this.level ) this.gameInstance.Data.display( "onLevelUp", 1 );
 
        return this.level;
    }

    public decrease( amount:number=1 )
    {
        return this.increase(-1);
    }

    private refresh()
    {
        this.isComplete     = false;
        this.level          = 0;

        let table           = this.levelUpTable;
 
        for( let n =0; n< table.length; n++ )
        {
            var max = table[n];

            if( this.value>= max ) continue;
            
            if( this.value < max )
            {
                this.level          = n;  
                this.nextLevel      = this.level+1;
                this.max            = max; 
                this.min            = table[n-1] || 0;
                this.rank           = ARRAY.getWithin( this.rankNames, this.level );
                this.isFull         = this.value === max;
  
                if( this.level >= this.maxLevel ) this.setMax();
 
                return;  
            }
        }
  
        this.setMax();
    }

    private setMax()
    {
        this.level          = this.maxLevel; 
        this.nextLevel      = this.level; 
        this.isComplete     = true;
        this.rank           = ARRAY.lastItem( this.rankNames );
    }

    public reset()
    {
        this.value = this.gameInstance.Data.set( this.varName, 0 ); 
        this.refresh();
    }
 
};

export default UserXP;